<form [formGroup]="form" class="form-group" style="display: grid; grid-template-columns: 1fr 1fr 1fr;">
  
  <!-- Dropdown unificado sempre visível -->
  <div class="form-control" style="grid-column: 1 / span 2;">
    <div style="width: 200%; min-width: 400px; max-width: 600px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 8px; width: 100%;">
        <div>
          <label for="unifiedSelect">Cliente / Embarcação</label>
        </div>
        <div *ngIf="getFederalId() && getFederalId().trim() !== ''">
          <label style="color: #bbb; font-weight: 600;">{{ getFederalIdType() }}: {{ getFederalId() }}</label>
        </div>
      </div>
      <app-movement-select-unified 
        [form]="form"
        formControlName="unifiedSelection">
      </app-movement-select-unified>
    </div>
  </div>

  <div class="form-control" style="display: none;">
    <label>{{ getFederalIdType() }}</label>
    <input type="text" pInputText [value]="getFederalId()" disabled>
    <!-- Campo oculto para forçar a detecção de mudanças -->
    <input type="hidden" [value]="form?.get('customer')?.value?.id">
    <input type="hidden" [value]="form?.get('customer')?.value?.federalIdType">
  </div>

  <app-movement-select-sailor class="marginTop15" *ngIf="form.getRawValue()?.boat?.boatSailors.length > 0" [boat]="form.getRawValue()?.boat"
    formControlName="sailor">
  </app-movement-select-sailor>

  <app-movement-select-origin-movement-location class="marginTop15" [boat]="form.value?.boat"
    *ngIf="form.value.boat?.boatProfile === 'EVENTUAL' || form.value.boat?.boatProfile ==='WORKSHOP'" formControlName="movementLocationOrigin">
  </app-movement-select-origin-movement-location>
  <app-movement-select-origin-vacancy class="marginTop15" [form]="form.value" [boat]="form.value?.boat" [movementLocation]="form.value?.movementLocationOrigin"
    *ngIf="form.value.boat?.boatProfile === 'EVENTUAL' || form.value.boat?.boatProfile ==='WORKSHOP'" formControlName="vacancyOrigin">
  </app-movement-select-origin-vacancy>
</form>
